import { useQuery } from "@tanstack/react-query";
import { getPayPointsPublicIDTransactionsLatest } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export const useLatestPayPointTransaction = (publicID?: string | null) =>
  useQuery({
    queryKey: ["LATEST_PAY_POINT_TRANSACTION", publicID],
    queryFn: publicID
      ? processResponseWithApiProblemDetails(() =>
          getPayPointsPublicIDTransactionsLatest(publicID),
        )
      : undefined,
    enabled: !!publicID,
    // The "latest" transaction is a point-in-time redirect target: a cached answer is yesterday's
    // (already paid) transaction. Without this, the iOS shell — which navigates NFC/QR universal
    // links client-side, so the SPA and its cache survive between two scans — sent the second
    // scan back to the first, already paid transaction (ZS-1674).
    gcTime: 0,
  });
